import { systemApi } from '@/api'
import { message } from 'ant-design-vue'
import { AGREEMENT_TYPE_TITLE } from './constants'

/**
 * 拉取并展示协议弹窗
 * @param {object} modalState 含 visible/title/content/loading 的 reactive 对象
 * @param {string} type member_agreement | member_privacy
 */
export async function openAgreementModal (modalState, type) {
  try {
    modalState.loading = true
    modalState.visible = true
    modalState.title = AGREEMENT_TYPE_TITLE[type] || '协议'

    const res = await systemApi.allXieyi({ types: type })
    modalState.content = res?.data || '暂无内容'
  } catch (err) {
    console.error('获取协议内容失败', err)
    message.error(err?.msg || err?.message || '获取协议内容失败')
    modalState.visible = false
  } finally {
    modalState.loading = false
  }
}
